import { render, staticRenderFns } from "./FileViewer.vue?vue&type=template&id=88cb62de&scoped=true"
import script from "./FileViewer.vue?vue&type=script&lang=js"
export * from "./FileViewer.vue?vue&type=script&lang=js"
import style0 from "./FileViewer.vue?vue&type=style&index=0&id=88cb62de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cb62de",
  null
  
)

export default component.exports